import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './Components/Home/Home/Home';
import firebase from "firebase/app";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import About from './Components/About/About/About';
import Contact from './Components/Contact/Contact';
import Blogs from './Components/Blogs/Blogs';
import Works from './Components/Works/Works';
import Nofound from './Components/Shared/Nofound/Nofound';
// import { firebaseConfig } from './Components/Firebase/firebaseConfig';


// firebase.initializeApp(firebaseConfig);
// firebase.analytics();

function App() {
  return (
    <div className="fullBody">
      <Router>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/home">
          <Home />
        </Route>
        <Route path="/about">
          <About/>
        </Route>
        <Route path="/contact">
          <Contact/>
        </Route>
        <Route path="/blog">
          <Blogs/>
        </Route>
        <Route path="/projects">
          <Works/>
        </Route>
        <Route path="*">
          <Nofound/>
        </Route>
      </Switch>
    </Router>
    </div>
    
  );
}

export default App;
